module.exports = {
  name: 'submit', base: '_item', prototype: {
    element_selector: 'input[type=submit], button[type=submit]'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/submit.js
 ** module id = 37
 ** module chunks = 0
 **/